import { DefaultButton } from '../atomic';
import * as S from './Success.styled';

interface SuccessProps {
  image: string;
  title?: string;
  subTitle?: string;
  onClick: () => void;
  buttonTitle: string;
}

export default function Success({
  image,
  title,
  subTitle,
  onClick,
  buttonTitle,
}: SuccessProps) {
  return (
    <S.Container>
      <S.SuccessWrapper>
        <S.ImageBox>
          <img src={image} alt='success' />
        </S.ImageBox>
        {(title || subTitle) && (
          <S.DescBox>
            <strong>{title}</strong>
            <p>{subTitle}</p>
          </S.DescBox>
        )}
      </S.SuccessWrapper>
      <S.ButtonBox>
        <DefaultButton onClick={onClick}>{buttonTitle}</DefaultButton>
      </S.ButtonBox>
    </S.Container>
  );
}
